export const deepParseJSON = (value) => {
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return deepParseJSON(parsed);
    } catch {
      return value;
    }
  }

  if (Array.isArray(value)) {
    return value.map(deepParseJSON);
  }

  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = deepParseJSON(value[key]);
      return acc;
    }, {});
  }

  return value;
};

export const stringifyAndReplaceQuotes = (value) =>
  JSON.stringify(value, null, 2)
    .replace(/^{\n?/, '') // remove opening brace
    .replace(/\n?}$/, '') // remove closing brace
    .replace(/"([^"]+)":/g, '$1:'); // remove quotes from keys
